import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 12,
	viewBox: "0 0 13 12",
	fill: "#5162F4",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.47266 8.5C6.22852 8.49512 6.02832 8.41211 5.83789 8.21191L2.21973 4.52051C2.07324 4.36914 2 4.19336 2 3.97852C2 3.54883 2.35156 3.19238 2.77637 3.19238C2.99121 3.19238 3.19141 3.28516 3.34766 3.44629L6.46777 6.66406L9.59277 3.44629C9.75391 3.28516 9.94922 3.19238 10.1689 3.19238C10.5986 3.19238 10.9453 3.54883 10.9453 3.97852C10.9453 4.19336 10.8721 4.36914 10.7256 4.52051L7.10742 8.21191C6.91211 8.41211 6.71191 8.5 6.47266 8.5Z" })
});
export default SvgChevronDownreact;
